<template>
  <section class="hero is-dark is-fullheight">
    <div id="login" class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <figure class="avatar">
            <img src="images/logo-soveco.png" />
          </figure>
          <h3 class="title has-text-grey">Login</h3>
          <div v-if="!isEmptyObject(messageObj)" class="notification is-danger">
            {{ messageObj.title }}
            <span class="icon is-small">
              <img
                :src="[
                  messageShown ? 'images/drill_on.png' : 'images/drill_off.png',
                ]"
                @click.prevent="expandMessage"
              />
            </span>
            <div v-if="messageShown" id="messageBox">
              {{ messageObj.alert }}
            </div>
          </div>
          <p class="subtitle has-text-grey">
            {{ message }}
          </p>
          <div class="box">
            <form>
              <div class="field">
                <div class="control">
                  <input
                    v-model="login"
                    class="input is-large"
                    type="email"
                    placeholder="Login"
                    autofocus=""
                  />
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <input
                    v-model="password"
                    class="input is-large"
                    type="password"
                    placeholder="Password"
                    v-on:keyup="keymonitor"
                    ref="pw"
                  />
                </div>
              </div>
              <!--
							<div class="field">
								<label class="checkbox">
									<input
										v-model="rememberme"
										type="checkbox"
									>
									Ricordami
								</label>
							</div>
							-->
              <a
                class="button is-block is-info is-large"
                @click.stop.prevent="goLogin(false)"
                >Login</a
              >
            </form>
          </div>
          <p class="has-text-grey">
            <!--
						<a href="../">Password dimenticata</a> &nbsp;·&nbsp;
						<a href="../">Supporto</a>
						-->
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import axios from 'axios'

export default {
  name: 'Login',
  mixins: [UtilityMixin],
  data() {
    return {
      messageObj: {},
      messageShown: false,
      message: 'Autentificarsi per procedere',
      login: '',
      password: '',
      rememberme: false,
      apiServer: '',
      auth: {},
      prefs: {},
    }
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)

    vm.$nextTick(function () {
      vm.$localStorage.remove('auth')
      let uu = this.$route.query.d1
      let pp = this.$route.query.d2
      vm.doGetMessage()
      if (
        vm.lg !== null &&
        vm.lg !== undefined &&
        vm.pw !== null &&
        vm.lg !== undefined
      ) {
        vm.login = (' ' + vm.lg).slice(1)
        vm.password = (' ' + vm.pw).slice(1)
      } else {
        setTimeout(function () {
          let v_rmb_l = null //vm.$localStorage.get('lg')
          let v_rmb_p = null //vm.$localStorage.get('pw')
          let v_rmb_r = null //vm.$localStorage.get('rmbr')
          let v_zap_l = vm.$localStorage.get('zap_l')
          let v_zap_p = vm.$localStorage.get('zap_p')
          vm.$localStorage.remove('zap_l')
          vm.$localStorage.remove('zap_p')
          if (
            uu !== null &&
            pp !== null &&
            uu !== undefined &&
            pp !== undefined
          ) {
            vm.login = uu
            vm.password = pp
            vm.goLogin(true)
          } else if (v_zap_l !== null && v_zap_p !== null) {
            vm.login = v_zap_l
            vm.password = v_zap_p
            vm.goLogin(true)
          } else if (v_rmb_l !== null && v_rmb_p !== null) {
            vm.login = v_rmb_l
            vm.password = v_rmb_p
            vm.$refs.pw.focus()
          }
          if (v_rmb_r !== null) {
            vm.rememberme = v_rmb_r
          }
        }, 200)
      }
    })
  },
  methods: {
    keymonitor(event) {
      if (event.key == 'Enter') {
        this.goLogin(false)
      }
    },

    expandMessage() {
      const vm = this
      vm.messageShown = !vm.messageShown
    },

    async goLogin(isSpecial) {
      const vm = this
      if (!isSpecial) {
        vm.$localStorage.set('rmbr', vm.rememberme)
      }
      if (vm.login.length > 0 || vm.password.length > 0) {
        vm.auth = null
        await vm.doLogin(isSpecial)
      }
    },

    async loginguest(isSpecial) {
      const vm = this
      const response = await axios.post(vm.api_server + 'login_guest', {
        lg: vm.login,
        pw: vm.password,
        fl: isSpecial,
      })
      if (vm.checkTkn(response.data)) {
        vm.auth = response.data

        if (!isSpecial) {
          if (vm.rememberme) {
            vm.$localStorage.set('lg', vm.login)
            vm.$localStorage.set('pw', vm.password)
          } else {
            vm.$localStorage.remove('lg')
            vm.$localStorage.remove('pw')
          }
        }

        let today = vm.isoLocalDate(null).replace('T', ' ')
        if (today < vm.auth.inizio || today > vm.auth.fine) {
          vm.message = 'Password temporanea non abilitata'
          vm.$dialog.alert(vm.message).then(function (dialog) {})
        } else {
          await vm.doPrefs()
          await vm.doLog()
          await vm.doUserStatus()
          await vm.doSonde(true)
          vm.auth.tipo = 3
          vm.$localStorage.set('auth', JSON.stringify(vm.auth))
          vm.$router.push({ name: 'Map', params: { pcod: '' } })
        }
      } else {
        vm.message = 'Controllare Nome Utente o Password'
        vm.$dialog.alert(vm.message).then(function (dialog) {})
      }
    },
    async loginothers(isSpecial) {
      const vm = this
      const response = await axios.post(vm.api_server + 'login', {
        lg: vm.login,
        pw: vm.password,
        fl: isSpecial,
      })
      if (vm.checkTkn(response.data)) {
        if (!isSpecial) {
          if (vm.rememberme) {
            vm.$localStorage.set('lg', vm.login)
            vm.$localStorage.set('pw', vm.password)
          } else {
            vm.$localStorage.remove('lg')
            vm.$localStorage.remove('pw')
          }
        }
        vm.auth = response.data
        ServiceBus.setAuth(response.data)

        await vm.doPrefs()
        await vm.doLog()
        await vm.doUserStatus()
        await vm.doSonde(false)

        if (vm.auth.login_kft !== null) {
          await vm.doLoginKft()
        } else {
          vm.auth.flag_kft = false
        }
        let actia = await ServiceBus._getActia()
        if (actia) {
          vm.auth.flag_actia =
            actia.login.length > 0 && actia.password.length > 0
        } else {
          vm.auth.flag_actia = false
        }
        vm.$localStorage.set('auth', JSON.stringify(vm.auth))
        if (vm.auth.tipo === '1') {
          vm.$router.push({ name: 'ListUsers', params: { pcod: '' } })
        } else {
          if (vm.prefs.landing === '1') {
            vm.$router.push({ name: 'Map', params: { pcod: '' } })
          } else {
            vm.$router.push({ name: 'List', params: { pcod: '' } })
          }
        }
      } else {
        vm.message = 'Controllare Nome Utente o Password'
        vm.$dialog.alert(vm.message).then(function (dialog) {})
      }
    },

    async doLogin(isSpecial) {
      const vm = this
      let guest = vm.login.indexOf('-')
      if (guest >= 0) {
        await vm.loginguest(isSpecial)
      } else {
        await vm.loginothers(isSpecial)
      }
    },

    async doLoginKft() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'loginkft',
          {
            group: 'SV',
            password: vm.auth.password_kft,
            name: vm.auth.login_kft,
            token: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response.data.login === 'ok') {
          vm.auth.tkn_kft = response.data.token
          vm.auth.flag_kft = true
        } else {
          vm.auth.tkn_kft = null
          vm.auth.flag_kft = false
          console.log('kft failed')
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doLog() {
      const vm = this
      let data = {
        cod: vm.auth.cod,
        state: 1,
        date: new Date().toLocaleMysqlString(),
      }
      return await axios.post(vm.api_server + 'insert_logs', data, {
        headers: {
          Authorization: vm.auth.tkn,
        },
      })
    },

    async doUserStatus() {
      const vm = this
      let data = {
        cod: vm.auth.cod,
        state: 1,
        date: new Date().toLocaleMysqlString(),
      }
      return await axios.post(vm.api_server + 'update_user_status', data, {
        headers: {
          Authorization: vm.auth.tkn,
        },
      })
    },

    async doSonde(isGuest) {
      const vm = this
      const response2 = await axios.get(
        vm.api_server + 'getsonde/' + vm.auth.cod,
        {
          headers: {
            Authorization: vm.auth.tkn,
          },
        }
      )

      if (response2.data.tkn !== '') {
        vm.auth.sonde = response2.data
      } else {
        vm.message = 'Controllare Nome Utente o Password'
        vm.$dialog.alert(vm.message).then(function (dialog) {})
      }
    },

    async doGetMessage() {
      const vm = this
      // let date = new Date().toLocaleMysqlString()

      //let date = vm.reverseDate(new Date())
      let d = new Date()
      let date = vm.formatDate(d)
      console.log('*' + date + '*')

      const response = await axios.get(vm.api_server + 'get_message/' + date)
      console.log('doGetMessage')
      console.log(response)
      if (response.data.length > 0) {
        vm.messageObj = response.data[0]
      }
    },

    async doPrefs() {
      const vm = this
      const response = await axios.get(
        vm.api_server + 'get_prefs/' + vm.auth.cod,
        {
          headers: {
            Authorization: vm.auth.tkn,
          },
        }
      )

      if (vm.checkTkn(response.data)) {
        if (response.data) {
          vm.prefs = response.data
        } else {
          vm.prefs = {}
          vm.prefs.storico = 1
          vm.prefs.landing = '1'
          vm.prefs.sosta_min = 5
          vm.prefs.sosta_max = 240
          vm.prefs.bcg0 = '#68BC00'
          vm.prefs.bcg1 = '#D33115'
          vm.prefs.bcg2 = '#D33115'
          vm.prefs.bcg3 = '#D33115'
          vm.prefs.bcg4 = '#000000'
          vm.prefs.ttt0 = '#000000'
          vm.prefs.ttt1 = '#000000'
          vm.prefs.ttt2 = '#000000'
          vm.prefs.ttt3 = '#000000'
          vm.prefs.ttt4 = '#FFFFFF'
        }
        vm.$localStorage.set('prefs', JSON.stringify(vm.prefs))
      } else {
        vm.message = 'Controllare Nome Utente o Password'
        vm.$dialog.alert(vm.message).then(function (dialog) {})
      }
    },
  },
}
</script>
